import { connect } from 'react-redux';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { warningDialogSelector } from '../../../../../redux/product/product.selectors';
import { Content as ContentComponent } from './content';
const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(hidePopup());
  }
});
export const Content = connect(warningDialogSelector, mapDispatchToProps)(ContentComponent);